import * as React from "react"
import { LoadingBlock, LoadingCircle } from "@digits-shared/components/Loaders"
import colors from "@digits-shared/themes/colors"
import fonts from "@digits-shared/themes/typography"
import styled from "styled-components"
import {
  DETAILS_CONTENT_SPACING_LEFT,
  DETAILS_CONTENT_SPACING_RIGHT,
} from "src/frontend/components/OS/Details/Shared/Styles/shared"
import { Desktop } from "src/frontend/components/Shared/Responsive/Desktop"
import { InsightItem, type InsightItemProps } from "src/shared/components/Insights/Item"

/*
  STYLES
*/

const DetailsArea = styled.div`
  color: ${colors.secondary};
`

const InsightBubbleContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 16px;

  background: rgb(232, 236, 255);
  padding: 16px;
  margin: 13px ${DETAILS_CONTENT_SPACING_RIGHT}px ${DETAILS_CONTENT_SPACING_RIGHT}px
    ${DETAILS_CONTENT_SPACING_LEFT}px;
  border-radius: 8px;

  .mobile & {
    margin: 0 12px;
  }
`

const BubbleTitle = styled.div`
  font-weight: ${fonts.weight.heavy};
  margin-bottom: 2px;
  font-size: 14px;
  line-height: normal;
  background: ${colors.gradients.ai};
  background-clip: text;
  color: transparent;
`

const Stars = styled.img`
  border-radius: 50%;
  background: white;
  padding: 6px;
  width: 32px;
  height: 32px;
  position: relative;
`

const StyledInsightItem = styled(InsightItem)`
  padding: 0;
  align-items: flex-start;
  border: none;
`

/*
  INTERFACES
*/

/*
  COMPONENTS
*/

export const InsightBubble: React.FC<InsightItemProps> = ({
  className,
  insight,
  entities,
  intervalOrigin,
  parseDrivers,
}) => (
  <InsightBubbleContainer className={className}>
    <Desktop>
      <Stars src={require("static/images/icons/stars.gif")} />
    </Desktop>
    <DetailsArea>
      <BubbleTitle>Did you know?</BubbleTitle>
      <StyledInsightItem
        insight={insight}
        entities={entities}
        intervalOrigin={intervalOrigin}
        parseDrivers={parseDrivers}
      />
    </DetailsArea>
  </InsightBubbleContainer>
)

export const LoadingInsightBubble: React.FC = () => (
  <InsightBubbleContainer>
    <LoadingCircle width={38} height={38} margin={`0 ${DETAILS_CONTENT_SPACING_LEFT}px 0 0`} />
    <DetailsArea>
      <LoadingBlock display="block" height="14px" width="140px" margin="0 0 12px" />
      <LoadingBlock display="block" height="12px" width="100%" margin="3px 0" />
      <LoadingBlock display="block" height="12px" width="220px" margin="3px 0" />
    </DetailsArea>
  </InsightBubbleContainer>
)
